import {ShapeLineStyle} from '@dv5/domain'
import {FC} from 'react'
import {getShapeLineStyle, getShapeStrokeProps} from './shapeLineStyle'
import './ShapeLineStylePicker.less'

interface Props {
    value?: ShapeLineStyle
    mixed?: boolean
    onChange: (value: ShapeLineStyle) => void
}

const styles = [
    {value: ShapeLineStyle.SOLID, label: 'Solid'},
    {value: ShapeLineStyle.DOTTED, label: 'Dotted'},
    {value: ShapeLineStyle.DASHED, label: 'Dashed'},
]

export const ShapeLineStylePicker: FC<Props> = ({value, mixed = false, onChange}) => (
    <div
        className='shape-line-style-picker'
        role='group'
        aria-label={mixed ? 'Line style (mixed)' : 'Line style'}
        onMouseDown={event => {
            event.preventDefault()
            event.stopPropagation()
        }}
        onKeyDown={event => event.stopPropagation()}
        onKeyUp={event => event.stopPropagation()}
    >
        {styles.map(style => (
            <button
                key={style.value}
                type='button'
                className='shape-line-style-picker__button'
                title={`${style.label} line`}
                aria-label={`${style.label} line`}
                aria-pressed={!mixed && getShapeLineStyle(value) === style.value}
                onClick={event => {
                    event.stopPropagation()
                    onChange(style.value)
                }}
            >
                <svg width='24' height='16' viewBox='0 0 24 16' aria-hidden='true'>
                    <line x1='3' y1='8' x2='21' y2='8' stroke='currentColor' strokeWidth='2'
                          {...getShapeStrokeProps(style.value, 2)} />
                </svg>
            </button>
        ))}
    </div>
)
